import 'fastselect';

$(document).ready(function() {
    const $variantSelects = $('.variant-select');
    const $surveyDataContent = $('#survey-data-content');

    $surveyDataContent.hide();

    $variantSelects.on('change', function() {
        const awardId = $(this).data('award-id');
        const selectedValue = $(this).val();

        $('#survey_step_five_variant_' + awardId).val(selectedValue);

        checkAllVariantsSelected();
    });

    function checkAllVariantsSelected() {
        let allSelected = true;

        $variantSelects.each(function() {
            const awardId = $(this).data('award-id');
            const selectValue = $(this).val();
            const hiddenValue = $('#survey_step_five_variant_' + awardId).val();

            if ((!selectValue || selectValue === '') && (!hiddenValue || hiddenValue === '')) {
                allSelected = false;
                return false;
            }
        });

        if (allSelected) {
            $surveyDataContent.slideDown();
        } else {
            $surveyDataContent.slideUp();
        }
    }

    $variantSelects.each(function() {
        const awardId = $(this).data('award-id');
        const hiddenValue = $('#survey_step_five_variant_' + awardId).val();

        if (hiddenValue) {
            $(this).val(hiddenValue);
        }
    });

    checkAllVariantsSelected();
});

window.loadFormDivs = function (awardId) {
    $('.n-prizes__item').addClass('not-chosen');
    $('.n-prizes__item--' + awardId).removeClass('not-chosen');
    let button = $('.n-prizes__item--' + awardId).find('button');
    let productId = button.data('id');
    let url = button.data('url');
    let value = $('#survey_step_five_variantValue').val();
    url = url + '/' + value;
    $.ajax({
        url: url,
        type: 'POST',
        data: {},
        cache: false,
        contentType: false,
        processData: false,
        success: function (response) {
            let el =  $('#survey-variant-content');
            el.html(response);
            el.addClass('is-visible');
            $('#survey-data-content').addClass('is-visible');
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('imageModal');
    const modalImg = modal.querySelector('img');
    const closeBtn = modal.querySelector('.image-modal-close');

    document.querySelectorAll('.prize-image').forEach(function(picture) {
        picture.addEventListener('click', function() {
            const imgSrc = this.getAttribute('data-image');
            modalImg.src = imgSrc;
            modal.classList.add('active');
        });
    });

    closeBtn.addEventListener('click', function() {
        modal.classList.remove('active');
    });

    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            modal.classList.remove('active');
        }
    });
});
